import React from 'react';
import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { FaAward } from 'react-icons/fa6';

const Date = ({ block }) => {
  const { date } = block;

  const formattedDate = format(date, 'do MMM', { locale: enGB });

  return (
    <div className="date-wrapper">
      <FaAward className="icon" size={60} />
      <div className="table-date" style={{ textAlign: 'center' }}>
        {formattedDate}
      </div>
    </div>
  );
};

export default Date;
